import { render, staticRenderFns } from "./ShippingPaymentSection.vue?vue&type=template&id=c10b2de0&scoped=true&"
import script from "./ShippingPaymentSection.vue?vue&type=script&lang=js&"
export * from "./ShippingPaymentSection.vue?vue&type=script&lang=js&"
import style0 from "./ShippingPaymentSection.vue?vue&type=style&index=0&id=c10b2de0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c10b2de0",
  null
  
)

export default component.exports